/* 🤖 this file was generated by svg-to-ts */
export const matIconAlignHorizontalCenter: {
  name: 'align-horizontal-center';
  data: string;
} = {
  name: 'align-horizontal-center',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M11 2h2v5h8v3h-8v4h5v3h-5v5h-2v-5H6v-3h5v-4H3V7h8z"/></svg>`
};
